import React, { useState } from 'react'
import { CustomInput, CustomTable, HeaderComp } from '../../components'
import Template from '../../Template'
import Logo from '../../assets/CompLogo.png'
import { Col, Popconfirm, Row } from 'antd'
import { EyeFilled, DeleteOutlined } from '@ant-design/icons'


const data = [
    {
        key: '1',
        id: '1',
        organization: "The Children's house",
        logo: { Logo },
        website: 'thechildrenshouse.com',
        campaign: '192.168.1.1',
        created_date: '2022-03-29 10:55:39',
        demo_leads: '23',
    },
    {
        key: '2',
        id: '2',
        organization: "The Children's house",
        logo: { Logo },
        website: 'thechildrenshouse.com',
        campaign: '192.168.1.1',
        created_date: '2022-03-29 10:55:39',
        demo_leads: '23',
    },
    {
        key: '3',
        id: '3',
        organization: "The Children's house",
        logo: { Logo },
        website: 'thechildrenshouse.com',
        campaign: '192.168.1.1',
        created_date: '2022-03-29 10:55:39',
        demo_leads: '23',
    },
    {
        key: '4',
        id: '4',
        organization: "The Children's house",
        logo: { Logo },
        website: 'thechildrenshouse.com',
        campaign: '192.168.1.1',
        created_date: '2022-03-29 10:55:39',
        demo_leads: '23',
    },
    {
        key: '5',
        id: '5',
        organization: "The Children's house",
        logo: { Logo },
        website: 'thechildrenshouse.com',
        campaign: '192.168.1.1',
        created_date: '2022-03-29 10:55:39',
        demo_leads: '23',
    },
    {
        key: '6',
        id: '6',
        organization: "The Children's house",
        logo: { Logo },
        website: 'thechildrenshouse.com',
        campaign: '192.168.1.1',
        created_date: '2022-03-29 10:55:39',
        demo_leads: '23',
    },
];
const Organizaition = () => {
    const [open, setOpen] = useState(false);
    const [dataSource, setDataSource] = useState(data)
    const [organization, setOrganization] = useState(data)
    const emptyInput = () => setOrganization('')

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: 'Organization',
            dataIndex: 'organization',
            key: 'organization',
        },
        {
            title: 'Logo',
            dataIndex: 'logo',
            key: 'logo',
            render: (_, record) => {
                return (
                    <>
                        <img style={{ width: 40, height: 40, borderRadius: '50%' }} src={record.logo.Logo} />
                    </>
                );
            },
        },

        {
            title: 'Website',
            dataIndex: 'website',
            key: 'website',
        },
        {
            title: 'Campaign',
            dataIndex: 'campaign',
            key: 'campaign',
        },
        {
            title: 'Created Date',
            dataIndex: 'created_date',
            key: 'created_date',
        },
        {
            title: 'Demo leads',
            dataIndex: 'demo_leads',
            key: 'demo_leads',
        },

        {
            title: 'Action',
            dataIndex: 'delete_lead',
            key: 'delete_lead',
            align: 'center',
            width: 150,
            render: (_, record) => {
                return (
                    <>
                        <EyeFilled style={{ color: '#8D8D8D', fontSize: 20 }} onClick={() => console.log(record.id)} />
                        <Popconfirm title="Are you sure to delete this lead?" onConfirm={() => onDelete(record.id)}>

                            <DeleteOutlined style={{ color: 'red', fontSize: 20, marginLeft: 10 }} />
                        </Popconfirm>
                    </>
                );
            },
        },
    ];

    const onDelete = (key) => {
        setDataSource(prev => prev.filter(e => e.key !== key))
    }

    const onChange = (e) => {
        const { value } = e.target
        setOrganization(value)
        console.log(organization)
    }
    const onOk = () => {
        console.log(organization)
        emptyInput()
    }

    const popupContent = {
        title: 'Add new organization',
        body: <PopupContent onChange={onChange} value={organization} />
    }

    return (
        <Template
            headerTitle={['Reports', 'Organizations']}
        >
            <div className="item_comp" >
                <HeaderComp title="Leads Table" btnType='popup' popupContnent={popupContent} onOk={onOk} isOpen={open} open={() => setOpen(true)} close={() => { emptyInput(); setOpen(false) }} />
                <CustomTable data={dataSource} columns={columns} pagination />
            </div>
        </Template>
    )
}

export default Organizaition

const PopupContent = ({ onChange, value }) => {
    return (
        <>
            <div className='flex_ver flex_center' style={{ width: '100%', gap: 10 }}  >
                <CustomInput type='text'
                    value={value}
                    name='name'
                    label="Organization name"
                    onChange={onChange} />
            </div>
        </>
    )
}